import styled from "styled-components";
import { Alert } from "@mui/material";

const Theme = {
  success: {
    border: "1px solid #c7f9cc",
    iconColor: "#c7f9cc",
  },
  error: {
    border: "1px solid #c23f38",
    iconColor: "#c23f38",
  },
};

const Base = styled(Alert)`
  position: absolute;

  top: 92px;
  left: 25%;
  right: 25%;

  background-color: ${(props) =>
    props.theme.color.background.primary} !important;

  border: ${(props) => Theme[props.severity]?.border};

  .MuiAlert-message {
    color: ${(props) => props.theme.color.text.primary};

    font-family: ${(props) => props.theme.font.family};
    font-weight: 600;
  }

  .MuiAlert-icon {
    color: ${(props) => Theme[props.severity]?.iconColor} !important;
  }

  .MuiIconButton-root {
    color: #7f7f86 !important;
  }
`;

const Transaction = (props) => {
  return (
    <Base severity={props.severity} onClose={props.onClose}>
      {props.children}
    </Base>
  );
};

export { Transaction };
